<template>
  <form>
    <div id="div-dietary-diagnostic-create-form" class="vs-con-loading__container">
      <vx-card title="Criar" title-color="primary">
        <vs-row>
          <vs-col vs-type="flex" vs-align="center" vs-lg="3" vs-sm="12" vs-xs="12">
            <vs-input v-model="data.name" label-placeholder="Nome" class="mt-5 w-full" />
          </vs-col>

          <vs-col vs-type="flex" vs-align="center" vs-lg="3" vs-sm="12" vs-xs="12">
            <vs-input v-model="data.description" label-placeholder="Descrição" class="mt-5 w-full" />
          </vs-col>
          <vs-col vs-type="flex" vs-align="center" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>Opção padrão? &nbsp;</p>
            <vs-switch
              color="dark"
              icon-pack="feather"
              vs-icon-on="icon-check-circle"
              vs-icon-off="icon-slash"
              v-model="data.alwaysShow"
            >
              <span slot="on">Sim</span>
              <span slot="off">Nao</span>
            </vs-switch>
          </vs-col>

          <vs-col vs-type="flex" vs-align="center" vs-lg="3" vs-sm="12" vs-xs="12">
            <p>Possuí valor? &nbsp;</p>
            <vs-switch
              color="dark"
              icon-pack="feather"
              vs-icon-on="icon-check-circle"
              vs-icon-off="icon-slash"
              v-model="data.hasValueInput"
            >
              <span slot="on">Sim</span>
              <span slot="off">Nao</span>
            </vs-switch>
          </vs-col>
        </vs-row>

        <br />

        <vs-row>
          <vs-col vs-type="flex" vs-align="right" vs-lg="12" vs-sm="12" vs-xs="12">
            <vs-button @click="submit">Enviar</vs-button>
          </vs-col>
        </vs-row>
      </vx-card>
    </div>
  </form>
</template>

<script>
// import { Validator } from 'vee-validate';

// Service
import DietaryDiagnosticService from "../../../../services/DietaryDiagnosticService";

export default {
  components: {},
  props: {
    idDietaryDiagnosticCategory: {
      required: true
    }
  },
  data() {
    return {
      data: {
        id: 0,
        alwaysShow: false,
        idDietaryDiagnosticCategory: 0,
        name: "",
        description: "",
        hasValueInput: false
      },
      notifications: {
        notify: this.$vs.notify,
        dialog: this.$vs.dialog,
        errors: this.errors,
        showSucces: false,
        showError: true
      },
      defaultDivId: "div-dietary-diagnostic-create-form"
    };
  },
  methods: {
    async submit() {
      this.data.idDietaryDiagnosticCategory = this.$props.idDietaryDiagnosticCategory;
      await this.create();
    },
    async create() {
      this.openLoadingInDiv(this.defaultDivId);

      const payload = {
        data: this.data,
        notifications: this.notifications
      };

      payload.notifications.showSucces = true;
      payload.notifications.showError = true;

      await DietaryDiagnosticService.create(payload);

      this.closeLoadingDiv(this.defaultDivId);
    },
    openLoadingInDiv(divId) {
      this.$vs.loading({
        container: "#" + divId,
        scale: 0.6
      });
    },
    closeLoadingDiv(divId) {
      this.$vs.loading.close("#" + divId + " > .con-vs-loading");
    }
  }
};
</script>

<style scoped>
.label {
  padding-left: 5px;
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.7);
}
</style>